import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faEdit, faFilter, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        arrayResult: []
    }
    deleteRecords = (id) => {
        Swal.fire({
            title: 'Are you sure to Delete the Supplier?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get("suppliers/delete/" + id)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Deleted!', dataResult.data.msj, 'success')
                        this.ListarArrayResult(1);
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Canceled', '', 'info')
            }
        })
    };

    ListarArrayResult(page) {
        Swal.showLoading();
        let bname = document.getElementById('bname').value;
        if (bname == '') {
            bname = 0;
        }
        authAxios.get("suppliers/index/" + bname + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.data.status;
                if (status) {
                    Swal.fire('Token has Expired!', 'Re-Login', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    arrayResult: dataResult.data.data,
                    page: dataResult.data.total,
                    last: dataResult.data.last_page,
                    current: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarArrayResult(1);
    }
    render() {
        const { load, arrayResult, page, last, current } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddSuppliers"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Add Supplier</Link>
                        </div>
                        <div className="card-body">
                            <h4>Suppliers List</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-5">
                                    <input style={{ textTransform: 'uppercase' }} type="text" id="bname" name="bname" placeholder="Search for Supplier Name" className="form-control form-control-sm" />
                                </div>
                                <div className="col-xl-3">
                                    <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filter</button>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">
                                <div className="col-xl-12">
                                    <table className="table table-hover table-condensed table-sm">
                                        <thead className="thead-inverse">
                                            <tr>
                                                <th className="align-middle">SUPPLIER</th>
                                                <th className="align-middle">ADDRESS</th>
                                                <th className="align-middle">PHONE</th>
                                                <th className="align-middle">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {load}
                                            {
                                                arrayResult.map((itemArrayResult) => (
                                                    <tr key={itemArrayResult.ID_SUPPLIER}>
                                                        <td>{itemArrayResult.NAME}</td>
                                                        <td>{itemArrayResult.ADDRESS}</td>
                                                        <td>{itemArrayResult.PHONE}</td>
                                                        <td>
                                                            <div className="btn-group" role="group" aria-label="">
                                                                <Link
                                                                    className="btn btn-primary btn-sm"
                                                                    to={"/UpSuppliers/" + itemArrayResult.ID_SUPPLIER}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </Link>&nbsp;&nbsp;
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={() =>
                                                                        this.deleteRecords(itemArrayResult.ID_SUPPLIER)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={current}><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current)}>{current}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(current + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArrayResult(last)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Page</b> <span className="badge bg-primary">{current}</span> <b>of</b> <span className="badge bg-primary">{last}</span> | <b>Records</b> <span className="badge bg-success">{page}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;